import React from 'react';

const SvgEr = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="ER_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="ER_svg__b" fill="#fff">
        <use xlinkHref="#ER_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#ER_svg__a" />
      <path fill="#29C53F" mask="url(#ER_svg__b)" d="M0 0h28v10H0z" />
      <path fill="#579DED" mask="url(#ER_svg__b)" d="M0 10h28v10.667H0z" />
      <path fill="#F42D56" mask="url(#ER_svg__b)" d="M0 20l28-10L0 0z" />
      <circle
        stroke="#FFC63C"
        strokeWidth={1.333}
        mask="url(#ER_svg__b)"
        cx={8.667}
        cy={10}
        r={4}
      />
      <circle fill="#FFC63C" mask="url(#ER_svg__b)" cx={8} cy={8.667} r={1} />
      <circle
        fill="#FFC63C"
        mask="url(#ER_svg__b)"
        cx={9.333}
        cy={9.333}
        r={1}
      />
      <circle fill="#FFC63C" mask="url(#ER_svg__b)" cx={8.667} cy={8} r={1} />
      <circle fill="#FFC63C" mask="url(#ER_svg__b)" cx={8} cy={10} r={1} />
      <circle
        fill="#FFC63C"
        mask="url(#ER_svg__b)"
        cx={9.333}
        cy={10.667}
        r={1}
      />
      <circle fill="#FFC63C" mask="url(#ER_svg__b)" cx={8} cy={11.333} r={1} />
      <circle fill="#FFC63C" mask="url(#ER_svg__b)" cx={9.333} cy={12} r={1} />
    </g>
  </svg>
);

export default SvgEr;
